// Native & external imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LyTypographyModule } from '@alyle/ui/typography';
import { FormsModule } from '@angular/forms';
// Components
import { FauxSelectDropdownComponent } from './faux-select-dropdown/faux-select-dropdown.component';
import { ModalFooterComponent } from './modal-footer/modal-footer.component';
// Pipes
import { LocaleDatePipe } from '../../../src/pipes/localedate.pipe';
import { LocalePipesModule } from '../../../src/pipes/localepipes.module';
// Directives
import { ImageDragDirective } from './directives/file-drag-and-drop.directive';


@NgModule({
  declarations: [
    FauxSelectDropdownComponent,
    ModalFooterComponent,
    ImageDragDirective,
  ],
  imports: [
    CommonModule,
    LocalePipesModule,
    LyImageCropperModule,
    LyTypographyModule,
    FormsModule
  ],
  exports: [
    FauxSelectDropdownComponent,
    ModalFooterComponent,
    ImageDragDirective,
  ],
  providers: [LocaleDatePipe]
})
export class SharedUiComponentsModule { }
